document.addEventListener('DOMContentLoaded',function(){
// /******** function in view start  *********/
function isCompletelyBehindHeader(element) {
  const header = document.querySelector("header");
  const headerHeight = header.offsetHeight;
  const rect = element.getBoundingClientRect();
  return rect.bottom <= headerHeight;
}

window.addEventListener("scroll", function () {
  const productButtons = document.querySelector(".product-form-buttons");
  const stickyBar = document.querySelector(".sticky-add-to-cart__bar");

  if (!productButtons || !stickyBar) return;

  const rect = productButtons.getBoundingClientRect();

  const inViewport =
    rect.top < window.innerHeight && rect.bottom > 0;

  if (!inViewport) {
    stickyBar.setAttribute("data-stuck", "true");
  } else {
    stickyBar.setAttribute("data-stuck", "false");
  }
});
//   /******* function in view end *********/


const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    {
      threshold: 0.2
    }
  );

  document.querySelectorAll(".animate-left").forEach((el) => {
    observer.observe(el);
  });

document.addEventListener("click", (event) => {
  const label = event.target.closest(".variant-picker__form label");
  if (label) {
    const target = label.closest(".product-information__grid")?.querySelector(".product-information__media");
    if (target) {
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = target.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
});

new Swiper(".product-list-wrapper", {
  speed: 600,
  grabCursor: true,
  spaceBetween: 10,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true,
  },

  breakpoints: {
    0: {
      slidesPerView: 1.5,   
      slidesPerGroup: 1,   
      centeredSlides: true,
      loop: true,
      loopedSlides: 6,
    },

    500: {
      slidesPerView: 2.2,
      slidesPerGroup: 2,
      centeredSlides: true,
      loop: true,
      loopedSlides: 6,
    },

    1024: {
      slidesPerView: 4.2,
      slidesPerGroup: 4,
      centeredSlides: false,
      loop: false,
    }
  }
});


new Swiper(".section-friend-list", {
  speed: 600,
  grabCursor: true,
  spaceBetween: 10,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true,
  },

  breakpoints: {
    0: {
      slidesPerView: 1.5,   
      slidesPerGroup: 1,   
      centeredSlides: false,
      loop: false,
      // loopedSlides: 6,
    },

    500: {
      slidesPerView: 2.2,
      slidesPerGroup: 2,
      centeredSlides: false,
      loop: false,
      // loopedSlides: 6,
    },

    1024: {
      slidesPerView: 4.4,
      slidesPerGroup: 1,
      centeredSlides: false,
      loop: false,
    }
  }
});
});



// GSAP Animation

gsap.registerPlugin(SplitText, ScrollTrigger);

// Hidden initially
gsap.set(".sc-image-slider-bottom, .resource-list", { autoAlpha: 0 });

// Bottom Sections (Multiple Safe)
gsap.utils.toArray(".sc-image-slider-bottom").forEach(section => {
  gsap.to(section, {
    autoAlpha: 1,
    duration: 0.8,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      end: "bottom 20%",
      toggleActions: "play reverse play reverse"
    }
  });
});

// Resource List (Multiple Safe)
gsap.utils.toArray(".resource-list").forEach(section => {
  gsap.to(section, {
    autoAlpha: 1,
    duration: 0.8,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      end: "bottom 20%",
      toggleActions: "play reverse play reverse"
    }
  });
});


gsap.utils.toArray(".product-title-cstm").forEach(section => {

  let splitHeading = SplitText.create(
    section.querySelector("h2"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitHeading.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});


gsap.utils.toArray(".product-title-cstm").forEach(section => {

  let splitHeading = SplitText.create(
    section.querySelector("h5"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitHeading.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});


gsap.utils.toArray(".image-product-slider-title").forEach(section => {

  let splitHeading = SplitText.create(
    section.querySelector("h2"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitHeading.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});


gsap.set(".sc-image-slider-top, .product-title-cstm", { opacity: 1 });

// Top Section (Multiple Safe)
gsap.utils.toArray(".sc-image-slider-top").forEach(section => {

  let splitTop = SplitText.create(
    section.querySelector("h3"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitTop.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});

gsap.utils.toArray(".product-title-cstm").forEach(section => {

  let splitHeading = SplitText.create(
    section.querySelector("h3"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitHeading.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});


gsap.utils.toArray(".featured-heading-sct").forEach(section => {

  let splitHeading = SplitText.create(
    section.querySelector("h2"),
    { type: "chars" }
  );

  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  })
  .from(splitHeading.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out"
  });

});

// jdg heading

window.addEventListener("load", function() {

  let heading = document.querySelector(".jdgm-header h2");

  if(heading){

    let splitHeading = new SplitText(heading, { type: "chars" });

    gsap.from(splitHeading.chars, {
      y: 30,
      opacity: 0,
      stagger: 0.04,
      duration: 0.7,
      ease: "power3.out",
      scrollTrigger: {
        trigger: heading,
        start: "top 70%",
        once: true
      }
    });

  }
});

window.addEventListener("load", function() {
  let headingSlide = document.querySelector(".section-resource-list__content .product-title-cstm h3");

  if(headingSlide){

    let splitHeading = new SplitText(headingSlide, { type: "chars" });

    gsap.from(splitHeading.chars, {
      y: 30,
      opacity: 0,
      stagger: 0.04,
      duration: 0.7,
      ease: "power3.out",
      scrollTrigger: {
        trigger: headingSlide,
        start: "top 70%",
        once: true
      }
    });

  }
});



gsap.registerPlugin(SplitText, ScrollTrigger);

gsap.set(".elegant-content", { opacity: 1 });

gsap.utils.toArray(".elegant-content").forEach((section) => {

  let heading = section.querySelector("h2");
  if (!heading) return;

  let split = new SplitText(heading, { type: "chars" });

  gsap.from(split.chars, {
    y: 20,
    autoAlpha: 0,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });

});



// image animation
let mm = gsap.matchMedia();

mm.add("(max-width: 992px)", () => {

  gsap.from(".collage-1", {
    x: "-100%",
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".collage-section",
      start: "top 50%",
      toggleActions: "play none none reverse"
    }
  });

  gsap.from(".collage-4", {
    x: "100%",
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".collage-section",
      start: "top 30%",
      toggleActions: "play none none reverse"
    }
  });

  gsap.from(".collage-3", {
    x: "-50%",
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".collage-section",
      start: "top 50%",
      toggleActions: "play none none reverse"
    }
  });

  gsap.from(".collage-2", {
    y: "100%",
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".collage-section",
      start: "top 40%",
      toggleActions: "play none none reverse"
    }
  });

});
gsap.from(".banner-sct-grid .left-sct .image-sct", {
  x: "-100%",
  duration: 1.2,
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".banner-main-sct",
    start: "top 50%",
    toggleActions: "play none none reverse"
  }
});

gsap.from(".banner-sct-grid .right-sct .image-sct", {
  x: "100%",
  duration: 1.2,
  ease: "power3.out",
  scrollTrigger: {
    trigger: ".banner-main-sct",
    start: "top 50%",
    toggleActions: "play none none reverse"
  }
});

// featured item section animation
// document.querySelectorAll(".featured-item").forEach((card) => {

//   const rotateX = gsap.quickTo(card, "rotationX", { duration: 0.6, ease: "power3" });
//   const rotateY = gsap.quickTo(card, "rotationY", { duration: 0.6, ease: "power3" });

//   const img = card.querySelector("img");
//   const moveX = gsap.quickTo(img, "x", { duration: 0.6, ease: "power3" });
//   const moveY = gsap.quickTo(img, "y", { duration: 0.6, ease: "power3" });

//   window.addEventListener("pointermove", (e) => {

//     const centerX = window.innerWidth / 2;
//     const centerY = window.innerHeight / 2;

//     const percentX = (e.clientX - centerX) / centerX;
//     const percentY = (e.clientY - centerY) / centerY;

//     rotateX(percentY * -15);
//     rotateY(percentX * 15);

//     moveX(percentX * 20);
//     moveY(percentY * 20);
//   });

// });



gsap.registerPlugin(ScrollTrigger);

let tll = gsap.timeline({
  scrollTrigger: {
    trigger: ".products-wrapper",
    start: "top 0%",
    toggleActions: "play none none none"
  }
});

tll.from(".product-slides-image img", {
  y: "120%",
  opacity: 0,
  duration: 1.2,
  ease: "power3.out",
  stagger: 0.4
});
  